import { useEffect, useContext, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';

import { useGetDenounce } from '../../hooks/useDenounceService';

import Header from '../../components/Header/Header';
import BottomMenu from '../../components/BottomMenu/BottomMenu';
import Denounce from '../../components/Denounce/Denounce';
import MapVisualizer from '../../components/MapVisualizer/MapVisualizer';

import './DenounceDetails.scss';

function DenounceDetails() {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthorized } = useContext(AuthContext);
  const [, denounce] = useGetDenounce({ id: location?.state?.denounceId });
  const vectorFocus = denounce?.vector_focus;

  const [seeMap, setSeeMap] = useState(false);

  useEffect(() => {
    if (!isAuthorized) navigate('/login');
  }, [isAuthorized, navigate]);

  function handleClickSeeMap() {
    setSeeMap(!seeMap);
  }

  return (
    <div className="inner-page denounce-details-page">
      <Header
        showBackBtn
        hideBackBtnLabel
        pageTitle="Detalhes da Denúncia"
      />
      <div className="inner-page-content-container">
        {!seeMap && denounce ? (
          <Denounce
            denounce={denounce}
            handleClickSeeMap={handleClickSeeMap}
          />
        ) : vectorFocus ? (
          <MapVisualizer
            className="denounce-vector-focus-map"
            vectorFocus={denounce.vector_focus}
            handleClickHideMap={handleClickSeeMap}
          />
        ) : <p>...</p>}
      </div>
      <BottomMenu />
    </div>
  );
}

export default DenounceDetails;
